module.exports = __webpack_public_path__ + "img/dota2-avatar-lg.a3385b03.png";